const objectToQueryString = query => Object.keys(query)
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
  .join(`&`)

export default objectToQueryString
